(function($) {
  const videoPlay = () => {
    const play = $(".video-with-thumbnail__play");
    const thumbnail = $(".video-with-thumbnail__responsive img");
    const videoContainer = $(".video-with-thumbnail__responsive");
    const iframe = $(".video-with-thumbnail iframe");

    play.on("click", function(e) {
      e.preventDefault();
      const src =
        thumbnail.attr("data-youtube") +
        "?autoplay=1&rel=0&amp;controls=0&amp;showinfo=0"; // src: the original URL for embedding
      videoContainer.empty().append(iframe.attr({ src: src })); // $iframe: the original iframe for embedding
    });
  };

  $(document).ready(() => {
    videoPlay();
  });
})(jQuery);
